var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9b7f0321de4f809d55c3eff93c9ea8302fc71c32"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["eth-dapp-v2@staderlabs"]={id:"9b7f0321de4f809d55c3eff93c9ea8302fc71c32"};
      